import { object, string, number } from "yup";

export const heartRateSchema = object({
    pulse: number()
        .typeError("Pulse must be a number")
        .min(10, "Pulse must be greater than or equal to 10")
        .max(300, "Pulse must be less than or equal to 300")
        .required("Pulse is required"),
    location: string().required("Pulse location is required")
});